import { useSelector } from 'react-redux';
import React, { useState } from 'react';
import { MODELS } from '../../../../../Apis/Models';
import {TABLES} from "../../../../../Apis/Tables";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

const ControllerApp = () => {
    const [selectedList, setSelectedList] = useState([]);
    const [finalArray, setFinalArray] = useState([]);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [searchElement, setSearchElement] = useState('');
    const [bodyForExport, setBodyForExport] = useState('');
    const [simpleSearch, setSimpleSearch] = useState(false);
    const [search, setSearch] = useState(false);
    const [deleteControllerShow, setDeleteControllerShow] = useState(false);
    // Props to the filter window
    const moduleId = `${MODELS.HID}`;
    const option = TABLES.HID;
    const [criteria, setCriteria] = useState();


    return {
        moduleId,
        DEV,
        permission,
        setCriteria,
        option,
        bodyForExport,
        setBodyForExport,
        searchElement,
        setSearchElement,
        setSimpleSearch,
        search,
        setSearch,
        finalArray,
        selectedList,
        setSelectedList,
        deleteControllerShow,
        setDeleteControllerShow
    }

}

export default ControllerApp;
